/**
 * Bug 7995 - decide o toast de "Desconto família aplicado!" a partir do CALCULO de valores.
 *
 * `calculatedValues.hasFamilyDiscount` vem do carrinho da MuviHub (totals.discountType), que so traz
 * "DESCONTO FAMILIA" quando o legado aplicou o desconto de fato: poltronas do 1o trecho de ida, empresas
 * habilitadas e o familia sendo o maior desconto (cupom, Muvicard e poltrona promocional concorrem).
 * O front nao recria essa regra - a versao anterior (Bug 7860) contava as poltronas de ida de todos os
 * trechos e mostrava o toast numa conexao 2 + 1 em que o desconto nao existia.
 *
 * Avisa na transicao (nao aplicado -> aplicado), uma vez; `applied` e o novo valor da flag
 * `familyDiscountApplied`, que segue o calculo em qualquer etapa (o cupom e a escolha de destino ja a
 * gravam assim).
 */
export function resolveFamilyDiscountToast({ familyDiscountApplied, calculatedValues }) {
	const applied = !!(calculatedValues && calculatedValues.hasFamilyDiscount)
	return { notify: applied && !familyDiscountApplied, applied }
}
